import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      height: '100%',
      maxWidth: '800px',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '20px'
    },
    cardsContainer: {
      padding: '20px',
      display: 'flex',
      gap: '30px',
      marginTop: '20px',
      flexWrap: 'wrap',
      justifyContent: 'center'
    },
    containerlist: {
      marginRight: '20px',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      height: '100%',
      minHeight: '300px',
      width: '100%'
    },
    routeslist: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      height: '100%',
      width: '100%'
    },
    item: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      color: 'white',
      justifyContent: 'center'
    }
  })
)
